import { Component, ElementRef, Input } from '@angular/core';

@Component({
  selector: 'uex-layout-sidebar-brand',
  templateUrl: './brand.component.html',
  host: {
    class: 'uex-layout-sidebar-brand'
  }
})

export class LayoutSidebarBrandComponent {
  @Input('src') src: string;

  constructor(
    public elementRef: ElementRef
  ) { }
}
